import type { FaireProductEntity } from "../../entity_types/product";

export const p_9ma79tyqtg: FaireProductEntity = {
  token: "p_9ma79tyqtg",
  type: "product",
  name: "3 Layer Snake Bone Chain 18K Gold Plated Steel Necklace -FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/93abf11aa85cfdcc9ade04c5bfbecce343c1ebc37764bdba886029e7cb6e3ef8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/68cfe6c259617e2094205fd0700eeb6e4943eb30711ae4553c2832e6ca1eac33.jpeg",
  ],
  priceDollars: 8.24,
  description:
    "Type: pendant necklace\nMaterial: Stainless steel ，18K gold plated\nSize : 400mm +50mm\nProcess: Vacuum electroplating and manual polishing，Non - tarnish\nSurface : High Polish\n\n★Made of high quality stainless steel，Lead-free，Harmless to Human Body.\n★Perfect jewelry gifts",
  tags: [],
  msrpDollars: 20.61,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:02.717Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
